import {Injectable} from '@angular/core';
import {DocumentTemplateDataService} from './documentTemplateData.service';
import {AbstractDataServiceDtoSummaryAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {DocumentTemplateSummaryModel} from '../../../api/entity/documentTemplateSummary.model';
import {DocumentTemplateSummaryConverter} from '../../../api/entity/converter/documentTemplateSummary.converter';
import {DocumentTemplateModel} from '../../../api/entity/documentTemplate.model';
import {DocumentTemplateConverter} from "../../../api/entity/converter/documentTemplate.converter";
import {
    AbstractDataServiceDtoAdapter
} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";

@Injectable({ providedIn: 'root' })
export class DocumentTemplateDataServiceAdapter extends AbstractDataServiceDtoAdapter<DocumentTemplateModel, DocumentTemplateConverter> {
    constructor(dataService: DocumentTemplateDataService, converter: DocumentTemplateConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): DocumentTemplateModel {
        return new DocumentTemplateModel();
    }
}
